import background from "../../assets/images/banner-image.png";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    Banner: {
        display: "flex",
        flex: 1,
        width: '100',
        height: 'auto',
        position: 'relative',
        zIndex: 1,
    },
    bannerRow: {
        background:
            `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)), url(${background})`,
        backgroundRepeat: "no-repeat",
        height: '55vh',
        position: 'absolute',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        zIndex: -1,
        width: '100%',
       
    }
}));


export default function Banner({ children }) {

    const classes = useStyles();

    return (
        <div className={classes.Banner}>
            <div className={classes.bannerRow}></div>
            {children}
        </div>









    );
}
